import { render, staticRenderFns } from "./industryComparison.vue?vue&type=template&id=0afe3b4a&scoped=true"
import script from "./industryComparison.vue?vue&type=script&lang=js"
export * from "./industryComparison.vue?vue&type=script&lang=js"
import style0 from "./industryComparison.vue?vue&type=style&index=0&id=0afe3b4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afe3b4a",
  null
  
)

export default component.exports